import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header<{ scrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  z-index: 100;
  background-color: ${(props) =>
    props.scrolled ? 'var(--nav-background)' : 'transparent'};
  backdrop-filter: ${(props) => (props.scrolled ? 'blur(10px)' : 'none')};
  transition: background-color 0.3s ease, padding 0.3s ease;

  @media (max-width: 768px) {
    padding: 1rem 5%;
  }
`;

export const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text);

  img {
    height: 40px;
    width: auto;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavLink = styled(Link)`
  font-size: 1rem;
  font-weight: 500;
  color: var(--text);
  transition: color 0.2s;

  &:hover {
    color: var(--primary);
  }
`;

export const NavCta = styled.a`
  padding: 0.5rem 1.25rem;
  background-color: var(--primary);
  color: white;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background-color: #ff9470;
    transform: translateY(-2px);
  }
`;
